<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{path: '/home'}">首页</el-breadcrumb-item>
      <el-breadcrumb-item>产品检验统计</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <div class="twoform">
        <div>
          <el-form :model="inquireList" ref="addFormRef" label-width="80px" class="form">
            <el-form-item label="订单" prop="ID">
              <el-select v-model="inquireList.ID1" placeholder="请选择订单" clearable>
                <el-option v-for="item in ordersList" :key="item.ID" :label="item.OrderName" :value="item.ID">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div>
          <el-form :model="inquireList" ref="addFormRef" label-width="80px" class="form">
            <el-form-item label="订单" prop="ID">
              <el-select v-model="inquireList.ID2" placeholder="请选择订单" clearable>
                <el-option v-for="item in ordersList" :key="item.ID" :label="item.OrderName" :value="item.ID">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div class="btn1">
          <el-button type="primary" @click="getProductSp()">查 询</el-button>
        </div>
      </div>
      <!-- 产品信息表格 -->
      <el-table :data="ProductSpList" border stripe>
        <el-table-column type="index"></el-table-column>
        <el-table-column label="订单号" prop="Order_ID"></el-table-column>
        <el-table-column label="件1数量" prop="Part1_QTY"></el-table-column>
        <el-table-column label="件2数量" prop="Part2_QTY"></el-table-column>
        <el-table-column label="件3数量" prop="Part3_QTY"></el-table-column>
        <el-table-column label="装配质量结果" prop="Result"></el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
export default {
    data () {
        return {
            getTypeList: {
                page: '1',
                limit: '10',
                privateKey: '12a5081e-e354-bada-3952-7a0df30d8849',
                appIdentification: 'wms',
                tableName: 'Mes_Order'
            },
            // 订单信息表
            ordersList: [],
            //查询信息的表单数据
            inquireForm: {
                TypeName: '',
                ProductNO: '',
                ProductName: '',
                StorageLocationNO: ''
            },
            // 产品类型信息表
            ProductSpList: [],
            // 点击查询按钮查询到的信息
            inquireList: {
                ID1: '',
                ID2: ''
            }
        }
    },
    created () {
        this.getOrderList()
    },
    methods: {
        //调用接口获取产品检验信息
        async getProductSp () {
            let params = new URLSearchParams();
            params.append("num1", this.inquireList.ID1)
              params.append("num2", this.inquireList.ID2)
            params.append("privateKey", this.getTypeList.privateKey)
            params.append("appIdentification", this.getTypeList.appIdentification)
            console.log('5656' + params)
            const { data: res } = await this.$http.get('/WMS/ProductInspection', { params })
            console.log(res)
            console.log(res.data)
            if (res.code !== 0) {
                return this.$message.error('查询失败，请重试！')
            }
            this.ProductSpList = res.data
        },
        // 调用接口获取订单信息
        async getOrderList () {
            const { data: res } = await this.$http.get('/WMS/GeneralQuery', { params: this.getTypeList })
            console.log(res.data)
            this.ordersList = res.data
        },
    }
}
</script>

<style lang="less" scoped>
.form {
  display: flex;
}
.btn {
  margin-left: 1%;
}
.button {
  width: 130%;
}
.twoform {
  display: flex;
}
.btn1 {
  margin-left: 1%;
}
</style>

